/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import SignatureStatusModal from "./signatureStatusModal.vue";
export default {
  components: {
    VPagination,
    SignatureStatusModal,

  },
  data() {
  return {
    signerslist: [],
    baseurl: process.env.VUE_APP_Service_URL,
    envelopestatus: "",
    envolopid: "",
    iframeurl: "",
    showLoading: false,
    signingUrl: false,
    selectedenvelopid: "",
    selectedsignorder: "",
    selectedrecepientemal: "",
    testiframe: false,
    currentPage: 1,
    pageindex: 1,
    pagesize: 10,
    totalPage: 1,
    SortProperty: "",
    SortOrder: false,
    isSigningUrlFetching: false,
    isIframeLoading: false,
    SortOrderInt: 1,
    searchField: {
      documentTitle: "",
      status: "",
      createdAt: "",
    },
    datacorrected: {
      "sent": "Pending",
      "created": "Awaiting",
      "completed": "Signed",
    },
    // Signature status modal state
    showSignatureStatusModal: false,
    selectedDocumentTitle: "",
    selectedSignItems: [],
    defaultdate:"",
    defaultTime:"",
  };
},
  unmounted() {
    delete window.showAlert;
  },
  async mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultTime = localStorage.getItem("timeformat");
    window.showAlert = this.showAlert.bind(this);
    window.addEventListener("studyIdChanged", (event) => {
      this.Getsignerslist();
    }
    );
    this.Getsignerslist();
  },
  methods: {
    filter(date) {
      if (date) {
          return moment(date).format(this.defaultdate)
      }
    },
    toTime(data) {
      if (data) {
        return moment(data).format(this.defaultTime);
      }
    },
    async testingiframe() {
      this.testiframe = true;
    },
    async viewDocumentDetails(id, name) {
      this.$router.push({
        path: `/documentview/${id}/1`,
        query: { tab: "signed" },
      });
    },
    async showAlert(message) {
      this.signingUrl = false;
      console.log(message);
      const idtoken = store.getters.getIdToken;
      console.log("idtocken", idtoken);

      await axios
        .post(`${this.baseurl}/etmf/docusign/activatenextsigner?envelopeId=${this.selectedenvelopid}&signOrder=${this.selectedsignorder}&recipientEmail=${this.selectedrecepientemal}`,
          {},
          {

            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          this.Getsignerslist();
        })
        .catch((err) => {
          console.error(err)
        });

    },
    onIframeLoad() {
      // Iframe fully loaded → hide iframe loader
      this.isIframeLoading = false;
    },
    loadsignerslist: function (page) {
      this.currentPage = page;
      this.Getsignerslist();
    },
    async Getsignerslist() {
      const idtoken = store.getters.getIdToken;
      let studyid = store.getters.getStudyIs;
      this.showLoading = true
      await axios
        .get(
          `${this.baseurl}/etmf/document/getsignerdocuments?studyId=${studyid}&pageindex=${this.currentPage}&pagesize=10&sortProperty=${this.SortProperty}&sortOrder=${this.SortOrderInt}&documentTitle=${this.searchField.documentTitle}&recStatus=${this.searchField.status}&createdAt=${this.searchField.createdAt}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          const rawEntities = res.data.entities || [];
          this.signerslist = rawEntities.map((item) => {
            const recipients = Array.isArray(item.recipients) && item.recipients.length > 0
              ? item.recipients
              : [
                {
                  recipientEmail: item.createdByEmail || item.id || "1",
                  recipientSignOrder: 1,
                  recipientSignedDate: null,
                  recipientStatus: item.status || "New"
                }
              ];
            return {
              ...item,
              recipients
            };
          });
          console.log("this.signerslist", this.signerslist);
          this.totalPages = Math.max(1, Math.ceil(Number(res.data.totalCount) / 10));
          this.showLoading = false;

        })
        .catch((err) => {

          this.showLoading = false
          this.userList = []
          console.log("No data found in!", err)

        })
    },
    async searchDocuments() {
      this.currentPage = 1;
      this.Getsignerslist();
    },
    SortSelected(sortProp) {
      if (this.SortProperty === sortProp) {
        // Same column clicked → toggle sort direction
        this.SortOrder = !this.SortOrder;
      } else {
        // New column clicked → reset to ascending
        this.SortProperty = sortProp;
        this.SortOrder = true;
      }

      this.SortOrderInt = this.SortOrder ? 0 : 1;
      this.pageindex = 1;
      this.currentPage = 1;

      this.Getsignerslist();
    },
    getSignatureStatus(userlist) {
      const signItems = Array.isArray(userlist.signItems) ? userlist.signItems : [];
      const total = signItems.length;
      const signed = signItems.filter((item) => item.signed === true).length;
      return {
        signed,
        total,
        complete: total > 0 && signed === total,
      };
    },
    getSignatureStatus(userlist) {
      const signItems = Array.isArray(userlist.signItems) ? userlist.signItems : [];
      const total = signItems.length;
      const signed = signItems.filter((item) => item.signed === true).length;
      return {
        signed,
        total,
        complete: total > 0 && signed === total,
      };
    },
    openSignatureStatusModal(userlist) {
      this.selectedDocumentTitle = userlist.documentTitle;
      this.selectedSignItems = Array.isArray(userlist.signItems) ? userlist.signItems : [];
      this.showSignatureStatusModal = true;
    },
    closeSignatureStatusModal() {
      this.showSignatureStatusModal = false;
      this.selectedSignItems = [];
      this.selectedDocumentTitle = "";
    },

  },
};


